// extracted by mini-css-extract-plugin
export default {"small":"ZjJX17IThJLYbIod2oZNGw==","large":"NkXSnMjDz6unok+xwgpI1Q=="};